import { LowerCasePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import { MatCell, MatCellDef, MatColumnDef, MatHeaderCell, MatHeaderCellDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { StripeVerificationSessionSummaryDto } from '@workspace/data-types';
import { BaseDataTableCoreComponent, DataTableComponent, LuxonDatePipe } from '@workspace/ng-aura';
import { StripeVerificationSessionColumnKey } from './abstract-stripe-verification-sessions-data-table.component';
import { StripeVerificationSessionsDataTableFilterCoreComponent } from './filter/stripe-verification-sessions-data-table-filter.component';

@Component({
  selector: 'core-stripe-verification-sessions-data-table',
  templateUrl: './stripe-verification-sessions-data-table.component.html',
  imports: [
    DataTableComponent,
    MatSort,
    MatColumnDef,
    MatHeaderCellDef,
    MatHeaderCell,
    MatSortHeader,
    MatButtonModule,
    MatCellDef,
    MatCell,
    LuxonDatePipe,
    LowerCasePipe,
    MatIconModule,
    MatTooltipModule,
    StripeVerificationSessionsDataTableFilterCoreComponent,
    RouterModule,
  ],
})
export class StripeVerificationSessionsDataTableCoreComponent extends BaseDataTableCoreComponent<
  StripeVerificationSessionSummaryDto,
  StripeVerificationSessionColumnKey
> {}
